"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconBubbleButton = _interopRequireDefault(require("../IconBubbleButton"));

var _Stepper = require("./Stepper.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Stepper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Stepper, _React$PureComponent);

  var _super = _createSuper(Stepper);

  function Stepper() {
    var _this;

    _classCallCheck(this, Stepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var changeEvent = {
        target: {
          value: parseInt(value, 10)
        }
      };

      if (_this.props.onChange) {
        _this.props.onChange(changeEvent);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "decrementValue", function () {
      var _this$props = _this.props,
          value = _this$props.value,
          minValue = _this$props.minValue;
      var newValue = value - 1;

      if (!minValue || minValue && newValue >= minValue) {
        _this.handleChange(newValue);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "incrementValue", function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          maxValue = _this$props2.maxValue;
      var newValue = value + 1;

      if (!maxValue || maxValue && newValue <= maxValue) {
        _this.handleChange(newValue);
      }
    });

    return _this;
  }

  _createClass(Stepper, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          dataTestId = _this$props3.dataTestId,
          label = _this$props3.label,
          maxValue = _this$props3.maxValue,
          minValue = _this$props3.minValue,
          value = _this$props3.value,
          props = _objectWithoutProperties(_this$props3, ["className", "dataTestId", "label", "maxValue", "minValue", "value"]);

      var atMinLimit = minValue !== null && value <= minValue;
      var atMaxLimit = maxValue !== null && value >= maxValue;
      return /*#__PURE__*/_react.default.createElement(_Stepper.StyledStepper, _extends({
        className: className,
        "data-test-id": dataTestId
      }, props), label && /*#__PURE__*/_react.default.createElement("span", {
        className: "c-stepper-label",
        "data-test-id": "stepper-title"
      }, label), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-stepper-controls-wrapper",
        "data-test-id": "stepper-controls-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_IconBubbleButton.default, {
        colorTheme: "primaryGhost",
        dataTestId: "stepper-decrement-icon-bubble-button",
        disabled: atMinLimit,
        iconName: "minus",
        onClick: this.decrementValue
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "c-stepper-value-display",
        "data-test-id": "stepper-value"
      }, value), /*#__PURE__*/_react.default.createElement(_IconBubbleButton.default, {
        colorTheme: "primaryGhost",
        dataTestId: "stepper-increment-icon-bubble-button",
        disabled: atMaxLimit,
        iconName: "plus",
        onClick: this.incrementValue
      })));
    }
  }]);

  return Stepper;
}(_react.default.PureComponent);

_defineProperty(Stepper, "propTypes", {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Prop for adding label */
  label: _propTypes.default.string,

  /** Maximum stepper value */
  maxValue: _propTypes.default.number,

  /** Minimum stepper value */
  minValue: _propTypes.default.number,

  /** Change handler */
  onChange: _propTypes.default.func.isRequired,

  /** Value for the stepper */
  value: _propTypes.default.number.isRequired
});

_defineProperty(Stepper, "defaultProps", {
  className: '',
  label: '',
  maxValue: null,
  minValue: 0
});

var _default = Stepper;
exports.default = _default;